import React from 'react';
import styles from './analytics.module.scss';
import {useTranslation} from "react-i18next";
import OrderPurchase from "./Components/OrderPurchase/OrderPurchase";
import TotalVisits from './Components/TotalVisits/TotalVisits';
import DemographicVisits from './Components/DemographicVisits/DemographicVisits';
import LinkClicks from './Components/LinkClicks/LinkClicks';

const Analytics = () => {
  const {t} = useTranslation();

  return (
    <div className={styles.container}>
      <span className={styles.header}>{t('analytics')}</span>
      <div className={styles.main_box}>
        <div className={styles.graph_row_one}>
          <div className={styles.box}>
            <TotalVisits />
          </div>
          <div className={styles.box}>
            <LinkClicks />
          </div>
          <div className={styles.box}>
            <OrderPurchase />
          </div>
        </div>
        <div className={styles.graph_row_two}>
          <div className={styles.box_left}>
            <div className={styles.world_map}>
              <DemographicVisits />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Analytics;
